<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/admin">商品采购</a></el-breadcrumb-item>
    </el-breadcrumb>
    <div class="header-top-15">
      <el-card class="box-card">
        <div class="page_box_num">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="result.totalpages"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>

    <el-table
      :data="result.data"
      stripe
      style="width: 100%; margin-top: 10px"
      ref="multipleTable"
    >
      <el-table-column prop="item.title" label="图片" width="100"> </el-table-column>
      <el-table-column prop="item.title" label="商品信息" width="180"> </el-table-column>
      <el-table-column label="总代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.item.product_price.length > 0">
            {{ (scope.row.item.product_price[0].discount1 / 10) * scope.row.item.price }}
            {{ "(" + scope.row.item.product_price[0].discount1 + "折" + ")" }}
          </span>
          <span v-else>
            {{ (agent_data.level1_discount / 10) * scope.row.item.price }}
            {{ "(" + agent_data.level1_discount + "折" + ")" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="市代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.item.product_price.length > 0">
            {{ (scope.row.item.product_price[0].discount2 / 10) * scope.row.item.price }}
            {{ "(" + scope.row.item.product_price[0].discount2 + "折" + ")" }}
          </span>
          <span v-else>
            {{ (agent_data.level2_discount / 10) * scope.row.item.price }}
            {{ "(" + agent_data.level2_discount + "折" + ")" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="区代价格" :tree-props="{ product_price: 'product_price' }">
        <template slot-scope="scope">
          <span v-if="scope.row.item.product_price.length > 0">
            {{ (scope.row.item.product_price[0].discount3 / 10) * scope.row.item.price
            }}{{ "(" + scope.row.item.product_price[0].discount3 + "折" + ")" }}
          </span>
          <span v-else>
            {{ (agent_data.level3_discount / 10) * scope.row.item.price }}
            {{ "(" + agent_data.level3_discount + "折" + ")" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="item.price" label="价格"> </el-table-column>
      <el-table-column prop="stock_num" label="库存"> </el-table-column>
      <el-table-column prop="agent" label="代理权">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.agent"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleSwitch(scope.$index, scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">
          <el-button size="mini" @click="purchase(scope.$index, scope.row)"
            >采购</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="dialogFormVisible" custom-class="p_box_footer">
      <div slot="title">商品采购折扣</div>

      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="省代">
              <el-input
                v-model="price1"
                autocomplete="off"
                style="width: 9rem"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8"
            ><el-form-item label="市代">
              <el-input
                v-model="price2"
                autocomplete="off"
                style="width: 9rem"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="区代">
              <el-input
                v-model="price3"
                autocomplete="off"
                style="width: 9rem"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col>
            <div class="footer">
              <el-button type="primary" @click="addCart">加入购物车</el-button>
              <el-button type="primary" @click="addCart">采购</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogStoreVisible">
      <div slot="title">我的采购</div>
      <el-form>
        <el-row>
          <el-col
            ><p>商品名称：{{ product_stock.title }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item v-for="(v, i) in this.attrs" :key="i" :label="v.name">
              <el-checkbox-group v-model="checkList[i].list" @change="handleClick">
                <el-checkbox-button v-for="(k, j) in v.list" :key="j" :label="k" />
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-tag
                v-for="(item, index) in skuList"
                :key="index"
                closable
                :disable-transitions="false"
                @close="handleClose(item)"
              >
                {{ item[0] }}{{ item[1] }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
        <el-row v-for="(item, index) in skuList" :key="index">
          <el-col :span="10">
            <p style="margin-bottom: 0px">
              <el-input v-model="qty[index]" autocomplete="off"></el-input>
            </p>
          </el-col>
        </el-row>

        <el-row> </el-row>
      </el-form>
      <el-row>
        <el-col>
          <div>
            <el-button type="primary" @click="addCart(product_stock.id)"
              >加入购物车</el-button
            >
            <el-button type="primary" @click="addCart">采购</el-button>
            <el-button @click="dialogStoreVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStoreVisible = false"
              >确 定</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      colors: [],
      sizes: [],
      attrs: [],
      checkList: [
        {
          name: "颜色",
          list: [],
        },
        {
          name: "尺码",
          list: [],
        },
      ],
      skuList: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      price1: 0,
      price2: 0,
      price3: 0,
      qty: [],

      editeFlag: false,
      product_stock: {},

      dialog_msg_visible: false,
      page: 1,
    };
  },
  methods: {
    ...mapActions({
      getPurchaseDataAction: "getPurchaseDataAction",
      addPriceAction: "addPriceAction",
    }),
    addCart(id) {
      if (this.skuList.length == 0) {
        this.$message("请选择商品");
        return;
      }
      let goods_key = "goods_" + id;
      let arr = {};
      let i = 0;
      let sku_goods_key;
      this.qty.forEach((element) => {
        sku_goods_key = this.skuList[i].toString();

        let sku = {};
        if (!(goods_key in arr)) {
          this.$set(sku, sku_goods_key, element);
          this.$set(arr, goods_key, [sku]);
          console.log("tag", arr);
        } else {
          this.$set(sku, sku_goods_key, element);

          arr[goods_key].push(sku);
        }

        i++;
      });
      // let shop = { key: [] };
      let goods_cart = sessionStorage.getItem("goods_cart");

      if (goods_cart == null) {
        sessionStorage.setItem("goods_cart", JSON.stringify(arr));
      } else {
        goods_cart = JSON.parse(goods_cart);
        if (goods_key in goods_cart) {
          this.$set(goods_cart, goods_key, arr[goods_key]);
        } else {
          this.$set(goods_cart, goods_key, arr[goods_key]);
        }

        // let newdata = [];

        sessionStorage.setItem("goods_cart", JSON.stringify(goods_cart));
      }
      //sessionStorage.setItem("goods_cart", JSON.stringify(arr));
      this.updateSkuList();
      this.skuList = [];
      this.qty = [];
      this.dialogStoreVisible = false;
      console.log("tag", id);
    },

    //设置库存
    purchase(index, row) {
      this.dialogStoreVisible = true;

      this.product_stock = row.item;
      this.attrs = row.attrs;

      console.log(index, row);
    },
    changePage(e) {
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getPurchaseDataAction({ type: "post", page: this.page });
    },
    handleClick() {
      // 先清空数据，保证连续点击按钮，数据不会重复
      this.skuArray = [];
      this.skuList = [];

      // 将选中的规格组合成一个大数组 [[1, 2], [a, b]...]
      this.checkList.forEach((element) => {
        element.list.length > 0 ? this.skuArray.push(element.list) : "";
      });
      if (this.checkList.length < 2) {
        return;
      }
      if (this.skuArray.length > 0) {
        this.getSkuData([], 0, this.skuArray);
      }
    },
    // 递归获取每条SKU数据
    getSkuData(skuArr = [], i, list) {
      if (list.length < 2) {
        return;
      }
      for (let j = 0; j < list[i].length; j++) {
        if (i < list.length - 1) {
          skuArr[i] = list[i][j];

          this.getSkuData(skuArr, i + 1, list); // 递归循环
        } else {
          this.skuList.push([...skuArr, list[i][j]]); // 扩展运算符，连接两个数组
        }
      }
    },
    handleClose(tag) {
      var index = this.skuList.indexOf(tag);

      this.skuList.splice(index, 1);
    },
    updateSkuList() {
      for (let i = 0; i < this.checkList.length; i++) {
        this.checkList[i].list = [];
        // this.$set(this.checkList[i]["list"], "checked", false);
      }
    },
  },
  created() {
    this.getPurchaseDataAction({ type: "post", page: this.page });
  },
  mounted() {},
  //tableData
  computed: {
    ...mapState({
      result: (state) => state.purchase_order.result,
      agent_data: (state) => state.purchase_order.result.agent_data,
    }),
  },
  watch: {
    result(newdata, olddata) {
      console.log(newdata, olddata);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
